// Kept separate from article copy so public route discovery stays small.
export const guideSlugs = [
  'getting-started', 'business-verification', 'sign-in', 'business-profile', 'resources', 'services', 'package-lengths',
  'opening-hours', 'closures', 'pricing', 'booking-rules', 'booking-terms', 'payments',
  'documents', 'calendar', 'new-booking', 'change-booking', 'cancel-and-refund',
  'customers', 'memberships', 'team', 'website', 'social-links', 'domains',
  'notifications', 'product-feedback', 'reviews', 'reports', 'customer-booking', 'waitlist', 'customer-account', 'customer-data', 'share-page', 'troubleshooting',
] as const
export type GuideSlug = typeof guideSlugs[number]
export const guidePaths = ['/doc', ...guideSlugs.map((slug) => `/doc/${slug}`)]
